import { useCallback, useRef, useState } from 'react';
import { useRemote } from '../../Utils/Utils';
import { toastDanger } from '../popups/Toast';

// Bookmarked accounts first, then case-insensitive company name, then companyId
// so the order never depends on the order the DB returned the rows in (RES-1255).
// The locale is fixed so every user (and Jest) sees the same order; with it left
// undefined the browser locale decides, and the dropdown's top-5 cut could differ per user.
export const compareTenants = (a, b) => {
	const bookmarked = (b.isBookmarked ? 1 : 0) - (a.isBookmarked ? 1 : 0);
	if (bookmarked !== 0) return bookmarked;
	const byName = (a.companyName ?? '').localeCompare(b.companyName ?? '', 'en', { sensitivity: 'base' });
	if (byName !== 0) return byName;
	return (a.companyId ?? 0) - (b.companyId ?? 0);
}

export const sortTenants = (tenants) => [...(tenants ?? [])].sort(compareTenants);

// RemoteV2 rejects with the HTTP status; on these two it has already run the
// logout action, so there is nothing to retry and no toast to show.
const SESSION_GONE = [401, 418];

// The single account-switch implementation, shared by the profile dropdown and
// the Switch Account modal. The ref guards against double-activation; on
// success the page reloads, so the guard is only released on a retryable failure.
export const useTenantSwitch = (setSwitchingCompany) => {
	const remote = useRemote();
	const [switching, setSwitching] = useState(false);
	const switchingRef = useRef(false);

	const switchTenant = useCallback((tenant) => {
		if (switchingRef.current) return;
		switchingRef.current = true;
		setSwitching(true);
		setSwitchingCompany(true);
		remote.post(`/crm/tenants/${tenant.companyId}`).then(() => {
			window.location.href = `/?${Math.random()}`;
		}).catch((status) => {
			if (SESSION_GONE.includes(status)) return;
			switchingRef.current = false;
			setSwitching(false);
			setSwitchingCompany(false);
			toastDanger("Unable to switch account. Please try again.");
		});
	}, [remote, setSwitchingCompany]);

	return { switchTenant, switching };
}
